var map = {
	"./account-info-bg.png": "add4",
	"./alert-info-icon.png": "6671",
	"./arrow-circle-right-icon.png": "0afa",
	"./avatar-placeholder.png": "43ad",
	"./bottom-bg.png": "8a2c",
	"./calendar-icon.png": "a915",
	"./calendar.png": "401b",
	"./campaign-point.png": "d179",
	"./circle-info-icon.png": "a510",
	"./close.png": "04b3",
	"./clubcard-loyalty-with-qr-code.png": "d628",
	"./clubcard-loyalty.png": "a122",
	"./clubcard-online.png": "e1f2",
	"./coin-adjustment-in.png": "fb3e",
	"./coin-adjustment-out.png": "49b3",
	"./coin-exchange-banner.png": "c640",
	"./coin-transfer-in.png": "a38e",
	"./coin-transfer-out.png": "1409",
	"./copy.png": "e61d",
	"./coupon-image-placeholder.png": "553f",
	"./coupon-outline-icon.png": "7776",
	"./default-avatar.png": "889b",
	"./earn.png": "9537",
	"./error.png": "b948",
	"./expiry.png": "0a30",
	"./header-coin-history.png": "565f",
	"./history.png": "1c5f",
	"./idcard-icon.png": "f02c",
	"./info-notification-icon.png": "8df3",
	"./laser-id-card-icon.png": "680d",
	"./loading-spinner.png": "65d1",
	"./lotus-logo.png": "0a55",
	"./lotuss-coin.png": "a1fb",
	"./lotuss-logo.png": "5e9a",
	"./modal-bottom-barcode-bg.png": "ad2d",
	"./my-coupon-icon.png": "a6b6",
	"./no-image-placeholder-carausol.png": "ebb6",
	"./no-image-placeholder-single.png": "4742",
	"./no-transaction.png": "b82e",
	"./offer-icon.png": "f824",
	"./otp-icon.png": "3887",
	"./partner-coupon-banner.png": "29f1",
	"./qr-code-icon.png": "0599",
	"./redeem.png": "a8db",
	"./special-for-you-icon.png": "0714",
	"./try-again-icon.png": "a16f",
	"./unlink-confirmation-icon.png": "15ee",
	"./unlink-icon.png": "ffec",
	"./unlink-line-icon.png": "b47a",
	"./warning-confirmation-icon.png": "afcb",
	"./warning-no-internet-icon.png": "aa6d",
	"./warning-notification-icon.png": "c86a",
	"./warning-request-timeout-icon.png": "1c13",
	"./warning-token-expired-icon.png": "10ea",
	"./x-button.png": "e03e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";